import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import StatusBadge from '../components/StatusBadge'
import MetaPill from './MetaPill'

const METADATA_LABELS = {
  databaseId: 'Database ID',
  url: 'URL',
  firmId: 'Firm ID',
  orgId: 'Org ID',
  clientId: 'Client ID',
  environment: 'Environment',
  baseUrl: 'Base URL',
  instanceUrl: 'Instance URL',
  userId: 'User ID'
}

function parseConnectionData (data) {
  if (!data) return []
  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data
    return Object.entries(parsed)
      .filter(([, v]) => v != null && v !== '')
      .map(([key, value]) => ({
        key,
        label: METADATA_LABELS[key] || key,
        value: typeof value === 'object' ? JSON.stringify(value) : String(value)
      }))
  } catch (err) {
    return []
  }
}

function ConnectionHeader ({ connection }) {
  const metadata = useMemo(() => parseConnectionData(connection.data), [connection.data])
  const userAuthCount = connection.userAuthCount || 0
  const showDescription = connection.description && connection.description !== connection.displayName

  return (
    <div className='flex flex-col gap-sm'>
      <div>
        <div className='font-size-xl font-bold'>{connection.displayName}</div>
        {showDescription && (
          <div className='font-size-xs text-neutral-500'>{connection.description}</div>
        )}
      </div>
      <div className='flex items-center flex-wrap gap-lg'>
        {!!connection.allowUserAuth && (
          <StatusBadge
            variant='primary'
            title='Number of users who have authenticated with this connection'
          >
            {userAuthCount} user{userAuthCount === 1 ? '' : 's'} authenticated
          </StatusBadge>
        )}
        {!!connection.useAsFallback && <StatusBadge variant='warning'>Uncredentialed fallback</StatusBadge>}
        <MetaPill label='Domain' value={connection.domain} />
        <MetaPill label='Slug' value={connection.code} />
        {metadata.map(item => <MetaPill key={item.key} label={item.label} value={item.value} />)}
      </div>
    </div>
  )
}

ConnectionHeader.propTypes = {
  connection: PropTypes.shape({
    connectionId: PropTypes.number.isRequired,
    displayName: PropTypes.string,
    code: PropTypes.string,
    domain: PropTypes.string,
    description: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    allowUserAuth: PropTypes.number,
    useAsFallback: PropTypes.number,
    userAuthCount: PropTypes.number
  }).isRequired
}

export default ConnectionHeader
